jQuery(document).ready(function($) {
	new WOW().init();

	$(window).scroll(function() {
	    if ($(this).scrollTop() > 0) { // this refers to window
	        $('.header').addClass('scroll');
	    } else {
	    	$('.header').removeClass('scroll');
	    }
	});

 /* ====================== MOBILE HEADER ======================  */
	$(".header .menu-item-has-children").click(function(){
		$(this).addClass('active');
		$(this).find('.sub-menu').slideDown();
	});

	$(".header__nav-trigger").click(function(){
		$(this).toggleClass('active');
		$('.header .menu-main-menu-container').toggleClass('active');
	});

    $('p').each(function() {
        var $this = $(this);
        if ($this.html().replace(/\s|&nbsp;/g, '').length == 0)
            $this.remove();
    });

 /* ====================== SCROLL BUTTON ======================  */

 	$(".scroll-down").click(function(){
		$('html,body').animate({
		   scrollTop: $(".service-blocks").offset().top
		});
	});

/* ====================== INIT FUNCSTIONS ======================  */

	$('.additional-services__slider').owlCarousel({
	    nav: true,
	    items: 1,
	    dots: false,
	    smartSpeed: 1000,
	    autoplaySpeed: 1000,
	    loop: true,
	    autoplay:true,
	    autoplayTimeout:2000,
	    autoplayHoverPause:true,
	    responsive : {
		    600 : {
		        items: 2,
		        margin: 1,
		    },
		    768 : {
		        items: 3,
		        margin: 1,
		    },
		    992 : {
		        items: 4,
		        margin: 1,
		    },
		    1200 : {
		        items: 5,
		    }
		}
	});
	

    function masthead_carousel() {
        if($(window).width() < 600) {
            $('.masthead-home__slider').owlCarousel({
				nav: false,
			    items: 1,
			    dots: false,
			    smartSpeed: 1500,
			    autoplaySpeed: 1500,
			    loop: true,
			    autoplay:true,
			    autoplayTimeout:3000,
			    autoplayHoverPause:true,
			    margin: 30,
			});
        } else {
            $('.masthead-home__slider').trigger('destroy.owl.carousel').removeClass('owl-carousel owl-loaded');
			$('.masthead-home__slider').find('.owl-stage-outer').children().unwrap();
        }
    }

    masthead_carousel();

    $(window).resize(function(){
        masthead_carousel();
    })
});
